// AI Generated Test
import { Component, Input, ElementRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PAGE_PERFORMANCE_METRICS } from '@client/app/modules/page-performance/constants/page-performance-metrics';

@Component({
    selector: 'page-performance-page-details-load-sequence',
    standalone: false,
    template: `
        <div class="load-sequence-container" *ngIf="report">
            <div class="screenshots-container d-flex justify-content-between">
                <div class="screenshot" *ngFor="let screenshot of calculatedScreenshots; trackBy: trackByIndex">
                    <img [attr.src]="screenshot.data" alt="thumbnail">
                </div>
            </div>
            <div class="load-sequence-bar-container">
                <div class="load-sequence-bar d-flex align-items-stretch">
                    <div class="load-sequence load-sequence-low"
                         [style.width]="lowPercentage">
                    </div>
                    <div class="load-sequence load-sequence-medium"
                         [style.width]="mediumPercentage">
                    </div>
                    <div class="load-sequence load-sequence-high"
                         [style.width]="highPercentage">
                    </div>
                </div>
                <div class="metric-indicator-container"
                     [style.left]="getMetricIndicatorLeft(firstContentfulPaint)"
                     [style.display]="getMetricIndicatorDisplay()"
                     [ngbTooltip]="getMetricTooltip('fcp')"
                     [triggers]="'focus hover'"
                     [placement]="'auto right'"
                     [tooltipClass]="'text-ellipsis'">
                    <div class="align-items-center d-flex justify-content-center metric-indicator" [class]="getMetricIndicatorClass(firstContentfulPaint)">
                        <span>{{getMetricDisplayValue(firstContentfulPaint)}}s</span>
                    </div>
                    <p class="metric-indicator-text text-center" translate>FCP</p>
                </div>
                <div *ngIf="showNewMetrics" class="metric-indicator-container"
                     [style.left]="getMetricIndicatorLeft(largestContentfulPaint)"
                     [style.display]="getMetricIndicatorDisplay()"
                     [ngbTooltip]="getMetricTooltip('lcp')"
                     [triggers]="'focus hover'"
                     [placement]="'auto right'"
                     [tooltipClass]="'text-ellipsis'">
                    <div class="align-items-center d-flex justify-content-center metric-indicator" [class]="getMetricIndicatorClass(largestContentfulPaint)">
                        <span>{{getMetricDisplayValue(largestContentfulPaint)}}s</span>
                    </div>
                    <p class="metric-indicator-text text-center" translate>LCP</p>
                </div>
                <div *ngIf="showNewMetrics" class="metric-indicator-container"
                     [style.left]="getMetricIndicatorLeft(speedIndex)"
                     [style.display]="getMetricIndicatorDisplay()"
                     [ngbTooltip]="getMetricTooltip('si')"
                     [triggers]="'focus hover'"
                     [placement]="'auto right'"
                     [tooltipClass]="'text-ellipsis'">
                    <div class="align-items-center d-flex justify-content-center metric-indicator" [class]="getMetricIndicatorClass(speedIndex)">
                        <span>{{getMetricDisplayValue(speedIndex)}}s</span>
                    </div>
                    <p class="metric-indicator-text text-center" translate>SI</p>
                </div>
                <div *ngIf="showNewMetrics" class="metric-indicator-container"
                     [style.left]="getMetricIndicatorLeft(totalBlockingTime)"
                     [style.display]="getMetricIndicatorDisplay()"
                     [ngbTooltip]="getMetricTooltip('tbt')"
                     [triggers]="'focus hover'"
                     [placement]="'auto right'"
                     [tooltipClass]="'text-ellipsis'">
                    <div class="align-items-center d-flex justify-content-center metric-indicator" [class]="getMetricIndicatorClass(totalBlockingTime)">
                        <span>{{getMetricDisplayValue(totalBlockingTime)}}s</span>
                    </div>
                    <p class="metric-indicator-text text-center" translate>TBT</p>
                </div>
                <div *ngIf="!showNewMetrics" class="metric-indicator-container"
                     [style.left]="getMetricIndicatorLeft(firstMeaningfulPaint)"
                     [style.display]="getMetricIndicatorDisplay()"
                     [ngbTooltip]="getMetricTooltip('fmp')"
                     [triggers]="'focus hover'"
                     [placement]="'auto right'"
                     [tooltipClass]="'text-ellipsis'">
                    <div class="align-items-center d-flex justify-content-center metric-indicator" [class]="getMetricIndicatorClass(firstMeaningfulPaint)">
                        <span>{{getMetricDisplayValue(firstMeaningfulPaint)}}s</span>
                    </div>
                    <p class="metric-indicator-text text-center" translate>FMP</p>
                </div>
            </div>
            <div class="load-sequence-legend-container mt-12">
                <div class="mb-3 text-bold" translate>Loading times</div>
                <div class="load-sequence-legend-item"
                     [ngbTooltip]="'Less than 2 seconds' | translate"
                     [triggers]="'focus hover'"
                     [placement]="'auto bottom'"
                     [tooltipClass]="'text-ellipsis'">
                    <span class="load-sequence-indicator load-sequence-indicator-short text-v-middle mr-1"></span>
                    <span class="text-v-middle" translate>Short</span>
                </div>
                <div class="load-sequence-legend-item"
                     [ngbTooltip]="'From 2 seconds to 8 seconds' | translate"
                     [triggers]="'focus hover'"
                     [placement]="'auto bottom'"
                     [tooltipClass]="'text-ellipsis'">
                    <span class="load-sequence-indicator load-sequence-indicator-medium text-v-middle mr-1"></span>
                    <span class="text-v-middle" translate>Medium</span>
                </div>
                <div class="load-sequence-legend-item"
                     [ngbTooltip]="'Greater than 8 seconds' | translate"
                     [triggers]="'focus hover'"
                     [placement]="'auto bottom'"
                     [tooltipClass]="'text-ellipsis'">
                    <span class="load-sequence-indicator load-sequence-indicator-long text-v-middle mr-1"></span>
                    <span class="text-v-middle" translate>Long</span>
                </div>
            </div>
        </div>
    `,
})
export class PagePerformancePageDetailsLoadSequenceComponent implements OnInit, OnChanges {
    @Input() report: any;

    lowValue = 2000;
    highValue = 8000;
    lowPercentage = '0%';
    mediumPercentage = '0%';
    highPercentage = '0%';
    largestContentfulPaint = 0;
    firstContentfulPaint = 0;
    firstMeaningfulPaint = 0;
    speedIndex = 0;
    totalBlockingTime = 0;
    calculatedScreenshots: any[] = [];
    showNewMetrics = false;
    screenshots: any;
    metrics: any;
    observedFirstPaint = 0;
    frameTime = 0;
    maxValue = 0;
    firstVisualLoadedFrameIndex = 0;
    lastEmptyVisualFrameIndex = 0;
    firstMeaningfulPaintFrameIndex = 0;

    constructor (
        private elementRef: ElementRef,
        private translateService: TranslateService,
    ) {}

    ngOnInit () {
        this.initialize();
    }

    ngOnChanges (changes: SimpleChanges) {
        if (changes.report && changes.report.currentValue) {
            this.drawSequenceGraph();
        }
    }

    initialize () {
        this.lowValue = 2000;
        this.highValue = 8000;
        this.lowPercentage = '0%';
        this.mediumPercentage = '0%';
        this.highPercentage = '0%';
        this.largestContentfulPaint = 0;
        this.firstContentfulPaint = 0;
        this.firstMeaningfulPaint = 0;
        this.speedIndex = 0;
        this.totalBlockingTime = 0;
        this.calculatedScreenshots = [];
        if (this.report) {
            this.showNewMetrics = this.report.version === 'v2' || this.report.version === 'v3';
            this.drawSequenceGraph();
        }
    }

    drawSequenceGraph () {
        this.screenshots = this.report.audits['screenshot-thumbnails'].details;
        this.metrics = this.report.audits.metrics.details.items[0];
        this.firstContentfulPaint = this.metrics.firstContentfulPaint;
        this.firstMeaningfulPaint = this.metrics.firstMeaningfulPaint;
        this.largestContentfulPaint = this.metrics.largestContentfulPaint;
        this.speedIndex = this.metrics.speedIndex;
        this.totalBlockingTime = this.metrics.totalBlockingTime;
        this.observedFirstPaint = this.metrics.observedFirstPaint;
        this.frameTime = this.screenshots.scale / this.screenshots.items.length;
        this.calculateTimeline();

        setTimeout(() => this.getStyleOfOverlapingIndicator());
    }

    getMetricIndicatorClass (value: any) {
        if (value < this.lowValue) {
            return 'load-sequence-low';
        } else if (value < this.highValue && value > this.lowValue) {
            return 'load-sequence-medium';
        } else {
            return 'load-sequence-high';
        }
    }

    getMetricIndicatorLeft (value: any) {
        if (!this.maxValue) {
            return '0px';
        } else {
            return 'calc(' + ((value / this.maxValue) * 100).toFixed(2) + '% - 35px)';
        }
    }

    getMetricIndicatorDisplay () {
        return this.maxValue ? 'block' : 'none';
    }

    getMetricDisplayValue (value: any) {
        return (value / 1000).toFixed(1);
    }

    getMetricTooltip (metric: string) {
        let translation = '';

        if (metric === 'fcp') {
            translation = 'First Contentful Paint';
        }

        if (this.report.version === 'v1') {
            if (metric === 'fmp') {
                translation = translation + 'First Meaningful Paint 5';
            }
        }

        if (metric === PAGE_PERFORMANCE_METRICS.LCP.toLowerCase()) {
            translation = translation + 'Largest Contentful Paint ';
        }

        if (metric === PAGE_PERFORMANCE_METRICS.SI.toLowerCase()) {
            translation = translation + 'Speed Index';
        }

        if (metric === PAGE_PERFORMANCE_METRICS.TBT.toLowerCase()) {
            translation = translation + 'Total Blocking Time';
        }

        return translation;
    }

    getStyleOfOverlapingIndicator () {
        let verticalSpacing = 10;
        const elements = this.elementRef.nativeElement.querySelectorAll('.metric-indicator-text');
        const blocksArray = Array.from(elements).map((el: any) => {
            const bounds = el.getBoundingClientRect();
            return {
                el: el,
                left: bounds.left,
                right: bounds.right,
            };
        }).reverse();

        while (blocksArray.length) {
            const entry = blocksArray.pop();
            if (!entry) {
                continue;
            }

            const collision = blocksArray.some((entryItem: any) => {
                return (
                    (entry.left >= entryItem.left && entry.left <= entryItem.right) ||
                    (entryItem.left >= entry.left && entryItem.left <= entry.right)
                );
            });

            if (collision) {
                verticalSpacing += 15;
                entry.el.style.setProperty('margin-top', verticalSpacing + 'px');
            }
        }
    }

    calculateTimeline () {
        this.maxValue = Math.max(
            this.firstContentfulPaint,
            this.firstMeaningfulPaint,
            this.largestContentfulPaint,
            this.speedIndex,
            this.totalBlockingTime,
            this.observedFirstPaint,
        );

        if (this.lowValue >= this.maxValue) {
            // Fill the whole bar with low value's color if the largest metric is less than the lowValue
            this.lowPercentage = '100%';
            this.mediumPercentage = '0%';
            this.highPercentage = '0%';
        } else if (this.lowValue < this.maxValue && this.maxValue < this.highValue) {
            // If the time to interactive is smaller than highValue, calculate medium percentage by the largest metric
            this.lowPercentage = ((this.lowValue / this.maxValue) * 100).toFixed(2) + '%';
            this.mediumPercentage = (((this.maxValue - this.lowValue) / this.maxValue) * 100).toFixed(2) + '%';
            this.highPercentage = '0%';
        } else {
            this.lowPercentage = ((this.lowValue / this.maxValue) * 100).toFixed(2) + '%';
            this.mediumPercentage = (((this.highValue - this.lowValue) / this.maxValue) * 100).toFixed(2) + '%';
            this.highPercentage = (((this.maxValue - this.highValue) / this.maxValue) * 100).toFixed(2) + '%';
        }

        this.firstVisualLoadedFrameIndex = Math.floor(this.observedFirstPaint / this.frameTime);
        this.lastEmptyVisualFrameIndex = Math.floor((this.firstContentfulPaint * 10) / this.maxValue);
        this.firstMeaningfulPaintFrameIndex = Math.floor((this.firstMeaningfulPaint * 10) / this.maxValue);
        this.calculatedScreenshots = [];
        for (let i = 0, j = 0; i < 10; i++) {
            // Push empty screenshots
            if (i < this.lastEmptyVisualFrameIndex) {
                this.calculatedScreenshots.push(this.screenshots.items[0]);
            } else {
                if (this.screenshots.items[this.firstVisualLoadedFrameIndex + j]) {
                    this.calculatedScreenshots.push(this.screenshots.items[this.firstVisualLoadedFrameIndex + j]);
                    j++;
                } else {
                    this.calculatedScreenshots.push(this.screenshots.items[this.screenshots.items.length - 1]);
                }
            }
        }
    }

    trackByIndex (index: number, item: any) {
        return index;
    }
}
